import React from "react";

import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";

import { ADMIN_USERS_ROUTE } from "./routes";
import UserProfile from "../../models/UserProfile";
import AdminUsersList from "../adminUsers/AdminUsersList";
import SingleAdminPage from "../adminUsers/SingleAdminPage";

import type { FunctionComponent, JSX } from "react";
import type { RouteComponentProps } from "react-router-dom";

import type { AppState } from "../../reducers";

interface IAdminRoute {
  component: FunctionComponent<RouteComponentProps>;
  path: string;
  exact: boolean;
}

function AdminRoute({
  component: Component,
  path,
  exact,
}: IAdminRoute): JSX.Element {
  const loggedUser = useSelector((state: AppState) => state.fetchReducer.user);

  const isOwnerOrAdmin = loggedUser?.isFetched
    ? new UserProfile(loggedUser.data).isOwnerOrAdmin
    : true; // we need to assume its true to avoid redirecting before even getting the roles

  return (
    <Route
      exact={exact}
      path={path}
      render={({
        history,
        location,
        match,
        staticContext,
      }: RouteComponentProps): JSX.Element =>
        isOwnerOrAdmin ? (
          <Component
            history={history}
            location={location}
            match={match}
            staticContext={staticContext}
          />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
}

function AdminUserRoutes(): JSX.Element {
  return (
    <React.Fragment>
      <AdminRoute exact component={AdminUsersList} path={ADMIN_USERS_ROUTE} />
      <AdminRoute
        exact
        component={SingleAdminPage}
        path={`${ADMIN_USERS_ROUTE}/:id`}
      />
    </React.Fragment>
  );
}

export default AdminUserRoutes;
